import { Moment } from "~/decorators/moment/momentDecorator";
import { BaseModel } from "./baseModel";

export class PRMMicPirce extends BaseModel {
    public mic:number;
    public price:number;
    @Moment()
    public date:moment.Moment;
}